import type {EditableTableSortEntry} from '../../ui/EditableTable/EditableTable';
import type Transaction from '../../entities/transaction';

/**
 * Sort configuration for the Support → Bad Transactions table.
 *
 * Extracted into its own module (no runtime imports) so the OWA-407 regression
 * test in EditableTable.test.tsx can exercise the EXACT production sort config
 * without rendering the Redux-connected BadTransactions page.
 *
 * OWA-407: the `date` column renders `format(tr.txDate, 'yyyy-MM-dd')` from a
 * derived row object, but the table's items are `Transaction` entities, which
 * have no `date` field — only `txDate` (a `Date`). An untyped `{label: 'date'}`
 * sortProp therefore read `transaction['date']` === undefined and the column was
 * a silent no-op. We sort by the underlying `txDate` via an explicit comparator
 * so the column orders chronologically.
 */
export const BAD_TRANSACTIONS_SORT_PROPS: EditableTableSortEntry<Transaction>[] = [
    {label: 'transactionId'},
    {label: 'date', type: 'date', sortFn: (a, b) => (a.txDate?.getTime() ?? 0) - (b.txDate?.getTime() ?? 0)},
    {label: 'relatedEntity'},
    {label: 'code'},
    {label: 'clients'},
    {label: 'type'},
    {label: 'amount'},
    {label: 'sourceType'},
    {label: 'targetType'},
    {label: 'reasonCode'},
    {label: 'reasonMessage'},
];
